// extracted by mini-css-extract-plugin
export var body = "styles-module__body___t_M9P";
export var container = "styles-module__container___IfEJM";
export var dividerBars = "styles-module__dividerBars___MsUQn";
export var expand = "styles-module__expand___smQpC";
export var title = "styles-module__title___XntBn";
export var truncate = "styles-module__truncate___mTVZn";